<script lang="ts">
  import { _ } from "svelte-i18n"
  import { flows } from "../../store"
  
  import Tooltip from '../../../../ui/Tooltip/Tooltip.svelte'
  import FlowSelect from "./components/FlowSelect/FlowSelect.svelte"
</script>

<div class="top-panel">
  <div class="flex items-center">
    <div class="title">
      {$_('flowProgram')}
    </div>

    <Tooltip tooltip={$_('flowProgramQuestion')}>
      <i class="icon-question" />
    </Tooltip>
  </div>

  {#if $flows.length > 1}
    <FlowSelect />
  {/if}
</div>

<style lang="scss">
  .top-panel {
    display: flex;
    align-items: center;

    i {
      color: rgba(90, 95, 109, 0.6);
      margin-right: 20px;
      cursor: pointer;

      &::before {
        margin: 0;
      }
    }

    @media (max-width: 576px) {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  .title {
    margin-right: 8px;
    font-size: 20px;
    font-weight: 600;
    line-height: 29px;
    color: #5A5F6D;
    white-space: nowrap;

    @media (max-width: 576px) {
      font-size: 18px;
    }
  }
</style>